import React from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
  }

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    const { children, fallbackUi } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return fallbackUi;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallbackUi: PropTypes.node,
};

ErrorBoundary.defaultProps = {
  fallbackUi: null,
};

export default ErrorBoundary;
